import { Component, h } from 'preact';

export class TextTrimComponent extends Component<
  {
    className?: string;
    maxHeight?: number;
    onTrim(isTrimmed: boolean): void;
  },
  {}
> {
  /**
   * @inheritDoc
   */
  public componentDidMount(): void {
    this.checkTrimNeeded();
  }

  /**
   * @inheritDoc
   */
  public componentDidUpdate(): void {
    this.checkTrimNeeded();
  }

  /**
   * @inheritDoc
   */
  public render(): preact.JSX.Element {
    return <div className={this.props.className}>{this.props.children}</div>;
  }

  /**
   * Checks if trim is needed
   */
  private checkTrimNeeded(): void {
    const maxHeight = this.props.maxHeight || (this.base as HTMLElement).getBoundingClientRect().height;

    if (maxHeight >= (this.base as HTMLElement).scrollHeight) {
      this.props.onTrim(false);

      return;
    }

    this.props.onTrim(true);
  }
}
